import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './fonts/Poppins-Regular.ttf';
import './fonts/Poppins-Medium.ttf';
import './fonts/Poppins-SemiBold.ttf';
import './fonts/Poppins-Bold.ttf';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import TagManager from 'react-gtm-module';
import { ThemeProviderWrapper } from './utils/DarkModeConfig';

const RECAPTCHA_KEY_V3 = '6LcNPr4qAAAAADW7FXsBQmBghF-2AgYTYHKVrFYa'

TagManager.initialize({ gtmId: 'G-MKSB4VBHHV' });

ReactDOM.render(
    <ThemeProviderWrapper>
    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_KEY_V3}>
    <App />
    </GoogleReCaptchaProvider></ThemeProviderWrapper>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
if (module.hot) { // enables hot module replacement if plugin is installed
    module.hot.accept();
}
